import { render, staticRenderFns } from "./ProfitFeatureCard.vue?vue&type=template&id=8438a06c"
import script from "./ProfitFeatureCard.vue?vue&type=script&lang=js"
export * from "./ProfitFeatureCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports